import { API_URL_V1 } from "../constants";

const RECOMBEE_API_URL = `${API_URL_V1}/recombee`;

export const mostPurchaseProducts = `${RECOMBEE_API_URL}/get-last-purchase`;

export const relatedWhatYouSaw = `${RECOMBEE_API_URL}/related-what-you-saw`;

export const mostPurchasedCategory = `${RECOMBEE_API_URL}/most-purchased-category`;

export const mostPurchasedHub = `${RECOMBEE_API_URL}/most-purchased-hub`;
